// material-ui
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// project import
import { useUserInfo } from 'hooks/useUserInfo';

// assets
import { SafetyCertificateOutlined } from '@ant-design/icons';

// react-router
import { useNavigate } from 'react-router-dom';

// ==============================|| HEADER CONTENT - PM MANDATES (RISK) BUTTON ||============================== //

export default function RiskButton() {
  const { isAdmin, isRiskAnalyst } = useUserInfo();
  const navigate = useNavigate();

  // Risk team (RiskAnalysts role) and admins only.
  if (!isAdmin && !isRiskAnalyst) {
    return null;
  }

  return (
    <Tooltip title="PM Mandates (Risk)">
      <IconButton color="secondary" onClick={() => navigate('/pm-mandates')} sx={{ color: 'text.primary' }}>
        <SafetyCertificateOutlined />
      </IconButton>
    </Tooltip>
  );
}
